import React, { useState, useEffect, useCallback } from "react";
import { withTranslation } from "react-i18next";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import Page from "components/Page";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { debounce, uniqBy } from "lodash";
import useHandleApiError from "hooks/useHandleApiError";
import useRemoveCache from "hooks/useRemoveCache";
import { useOfficeDetail } from "repositories/office-repository";
import {
  useLeaveListing,
  updateLeaveStatus,
  cancelLeave,
  archiveLeave,
} from "repositories/leave-repository";
import { setStorage, getStorage, decodeId, encodeId } from "utils";
import Empty from "components/Empty";
import Loader from "components/Loader";
import toast from "react-hot-toast";
import styles from "./StaffListingLeaves.module.scss";
import "./StaffListingLeaves.scss";
import constants from "../../../constants";
import LeavesTaskCard from "./component/LeavesTaskCard";
import RejectionModal from "../StaffListingTimesheet/component/RejectionModal";
import SeparatorIcon from "../../../assets/images/Line 169.svg";
import Button from "components/Button";
import Select, { components } from "react-select";
import SelectStaff from "accountOwner/pages/Notices/modals/SelectStaff";
import { getStaffMembers } from "repositories/contract-repository";
const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor:
      state.isFocused || state.isSelected ? "transparent" : "transparent",
    color: "#333",
    cursor: "pointer",
  }),
  control: (provided) => ({
    ...provided,
    borderColor: "#ccc",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#ccc",
    },
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "transparent",
  }),
  multiValueLabel: (base) => ({
    ...base,
    whiteSpace: "nowrap",
    fontSize: "14px",
    color: "#77928b",
    fontWeight: 500,
  }),
};

const leaveStatusList = [
  { value: 1, label: "Current Leaves" },
  { value: 2, label: "Past Leaves" },
  { value: 3, label: "Cancelled Leaves" },
  { value: 4, label: "Rejected Leaves" },
  { value: 5, label: "Archived Leaves" },
];

const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <div className="ch-checkbox c-field all-event-checkbox m-0">
        <label>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => {}}
            onClick={(e) => e.stopPropagation()}
          />
          <span>{props.label}</span>
        </label>
      </div>
    </components.Option>
  );
};

const MultiValue = (props) => {
  const { getValue } = props;
  const selectedValues = getValue();

  if (selectedValues.length === 1) {
    return <components.MultiValue {...props} />;
  }

  return null;
};

const CustomValueContainer = ({ children, ...props }) => {
  const selectedValues = props.getValue();

  if (selectedValues.length > 1) {
    return (
      <components.ValueContainer {...props}>
        <div className={styles.multiple_selected}>Multiple Selected</div>
      </components.ValueContainer>
    );
  }

  return (
    <components.ValueContainer {...props}>{children}</components.ValueContainer>
  );
};
export const leaveTags = {
  reject: "reject",
  accept: "accept",
  archive: "archive",
  unarchive: "unarchive",
  isConflictingLeave: "isConflictingLeave",
  backupUserId: "backupUserId",
  cancellationReject: "cancellationReject",
  cancellationAccept: "cancellationAccept",
  withdrawn: "withdrawn",
  cancel: "cancel",
};
const NoRemove = () => null;

const PAGE_SIZE = 5;
const pageSize = 20;
const StaffListingLeaves = ({ t, history, location }) => {
  const profile = useSelector((state) => state?.userProfile?.profile);
  const leaveListStatus = constants.LeaveStatus;
  const leaveListTypeStatus = constants.LeaveTypeStatus;
  const [leaveList, setLeaveList] = useState([]);
  let { officeId } = useParams();
  officeId = decodeId(officeId);
  const cacheValue = getStorage(constants.Leave.cache.leaveListing);
  const [pageNumber, setPageNumber] = useState(cacheValue?.pageNumber || 1);
  const [searchText, setSearchText] = useState("");
  const [apiSearchText, setApiSearchText] = useState("");
  const searchTerm = apiSearchText ? apiSearchText : "";
  const [selectedLeaveIds, setSelectedLeaveIds] = useState([]);
  const [pendingLeaveRecords, setPendingLeaveRecords] = useState([]);
  const [selectedLeaveStatus, setSelectedLeaveStatus] = useState(
    leaveListStatus[0].value
  );
  let status = selectedLeaveStatus;
  const [year, setYear] = useState(
    cacheValue?.year || new Date().getFullYear()
  );
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [selectedLeaveStatuses, setSelectedLeaveStatuses] = useState([]);
  const [isSelectStaffModalOpen, setiIsSelectStaffModalOpen] = useState(false);
  const [staffMembers, setStaffMembers] = useState([]);
  const [Selectedstaff, setSelectedStaff] = useState(null);
  const [stafftotalItems, setStaffTotalItems] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const isChatFromDashBoard = getStorage(
    constants.notes.cache.isChatFromDashBoard
  );

  const handleOfficeChange = (selectedOptions) => {
    setPageNumber(1);
    const selectedValues = selectedOptions?.map((option) => option?.value);
    setSelectedLeaveStatuses(selectedValues);
  };

  const { data: officeDetail } = useOfficeDetail(officeId);
  const selectedOwnerId = officeDetail?.ownerId;
  const {
    data,
    error: isError,
    isLoading,
    isFetching,
    refetch,
  } = useLeaveListing(
    officeId,
    status,
    year,
    pageNumber,
    PAGE_SIZE,
    searchTerm,
    selectedLeaveStatuses,
    selectedOwnerId,
    { enabled: !!selectedOwnerId }
  );

  let totalItems = data?.pagination?.totalPages * PAGE_SIZE;
  useHandleApiError(isLoading, isFetching, isError);

  useEffect(() => {
    setStorage(constants.Leave.cache.leaveListing, {
      pageNumber: pageNumber,
      year: year,
    });
  }, [pageNumber, year]);

  useRemoveCache([], constants.Leave.cache.leaveListing);

  useEffect(() => {
    //This use effect is very importent to run the column formatter on state changes.
    if (data?.data) {
      const leaveListUpdated =
        leaveList?.map((val) => {
          val.counter = val.counter + 1;
          return val;
        }) || [];

      setLeaveList([...leaveListUpdated]);
    }
  }, [selectedLeaveIds]);

  useEffect(() => {
    let dataToUpdate = [];
    if (data?.data) {
      let prev = data.data;
      const leaveListUpdated =
        prev?.leave?.map((val) => {
          val.counter = val.counter || 0 + 1;
          return val;
        }) || [];

      dataToUpdate = structuredClone([...leaveListUpdated]);
      setSelectedLeaveIds([]);
      window?.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }

    const pendingRecords = dataToUpdate.filter(
      (val) => val.status === leaveListStatus[1].value
    );
    setPendingLeaveRecords(pendingRecords);
    setLeaveList(dataToUpdate);
  }, [data?.data]);

  const handleStaffRadio = (id) => {
    setSelectedStaff(id);
  };

  const getStaff = async (searchTerm = "") => {
    setShowLoader(true);
    try {
      const res = await getStaffMembers(officeId, searchTerm, 1, pageSize);
      setStaffMembers(uniqBy([...res?.items], "id"));
      setStaffTotalItems(res?.pagination?.totalItems);
      setShowLoader(false);
      window?.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } catch (e) {
      setShowLoader(false);
    }
  };

  const debouncedGetStaff = useCallback(
    debounce((value) => {
      getStaff(value);
    }, 1000),
    [officeId, pageNumber]
  );

  const hanldeApplyModal = () => {
    setiIsSelectStaffModalOpen(true);
    getStaff();
  };

  useEffect(() => {
    debouncedGetStaff(searchValue);

    return () => {
      debouncedGetStaff.cancel();
    };
  }, [searchValue, debouncedGetStaff]);

  const handleApply = () => {
    setiIsSelectStaffModalOpen(false);
    history.push({
      pathname: constants.routes.staff.applyLeaves.replace(
        ":officeId",
        encodeId(officeId)
      ),
      state: { ...Selectedstaff },
    });
  };

  const handleCancelStaffModal = () => {
    setiIsSelectStaffModalOpen(false);
    setSelectedStaff(null);
  };

  const onBack = () => {
    if (isChatFromDashBoard) {
      history.push(constants.routes.dashboard.managerDashboard);
      return;
    }
    if (profile.isAdmin) {
      history.push({
        pathname: constants.routes.staff.officeAdmin.replace(
          ":officeId",
          encodeId(officeId)
        ),
        state: location.state,
      });
    } else {
      history.push(
        constants.routes.accountOwner.officeOptions.replace(
          ":officeId",
          encodeId(officeId)
        )
      );
    }
  };

  const handleEdit = (leaveDetail) => {
    history.push({
      pathname: constants.routes.staff.editLeaves.replace(
        ":officeId",
        encodeId(officeId)
      ),
      state: { ...leaveDetail },
    });
  };

  const currentYear = new Date().getFullYear();
  const yearsList = Array.from({ length: 10 }, (_, i) => {
    const yearValue = currentYear + 1 - i;
    return { label: yearValue, value: yearValue };
  });

  const handleSearchText = useCallback(
    debounce((searchTextValue) => {
      setPageNumber(1);
      setApiSearchText(searchTextValue);
    }, 1000),
    []
  );

  const handleChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
    handleSearchText(value);
  };

  const handleSelectedYear = (item) => {
    setYear(item?.value);
    updatePageNumber(1);
  };

  // const handleStatus = (item) => {
  //   setSelectedLeaveStatus(item?.value);
  //   updatePageNumber(1);
  // };

  const updatePageNumber = (page) => {
    setPageNumber(page);
  };

  const acceptRejectLeave = async (isApproved, reason) => {
    if (showLoader) return;
    setShowLoader(true);

    try {
      await updateLeaveStatus({
        id: selectedLeaveIds.toString(),
        isAccepted: isApproved,
        Comment: reason ?? "",
      });

      refetch();
      setSelectedLeaveIds([]);
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setShowLoader(false);
      setIsRejectionModalOpen("");
    }
  };

  const toggleAllCheckbox = (e) => {
    let selectedData = e.target.checked ? pendingLeaveRecords : [];
    let ids = selectedData.map((val) => val.id);

    setSelectedLeaveIds(ids);
  };

  const toggleCheckbox = (e, row) => {
    if (!e.target.checked) {
      setSelectedLeaveIds((prev) =>
        prev?.filter((it) => it !== +e.target.value)
      );
    } else {
      setSelectedLeaveIds((prev) => [...prev, +e.target.value]);
    }
  };

  const staffCancelLeaves = async (isApproved, reason = "") => {
    if (showLoader) return;
    setShowLoader(true);
    try {
      const params = {
        id: selectedLeaveIds.toString(),
        Comment: reason,
        IsStaff: false,
        IsCancel: isApproved,
        officeId: officeId,
      };
      let res = await cancelLeave(params);
      if (res.status) {
        toast.success(res.message);
        setSelectedLeaveIds([]);
        refetch();
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setShowLoader(false);
      setIsRejectionModalOpen("");
    }
  };
  const applyArchiveActions = async (isArchived) => {
    if (showLoader) return;
    setShowLoader(true);
    try {
      const params = {
        leaveId: selectedLeaveIds.toString(),
        isArchived: isArchived,
      };
      let res = await archiveLeave(params);
      if (res.status) {
        toast.success(res.message);
        setSelectedLeaveIds([]);
        refetch();
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setShowLoader(false);
      setIsRejectionModalOpen("");
    }
  };
  const setterIdAndModalOpen = (actionData, value) => {
    setSelectedLeaveIds([actionData?.id]);
    // modalSetter(value ?? true);
    setIsRejectionModalOpen(value);
  };
  const renderListing = () => (
    <div className={styles["card-container"]}>
      {!!leaveList?.length ? (
        leaveList.map((leave) => (
          <LeavesTaskCard
            key={leave.id}
            leaveDetail={leave}
            index={leave.id}
            leaveListStatus={leaveListStatus}
            leaveListTypeStatus={leaveListTypeStatus}
            handleAcceptRejectLeave={(actionData, isApproved, actionType) => {
              if (actionType === "Reject") {
                setterIdAndModalOpen(actionData, leaveTags.reject);
              } else if (actionType === "Accept") {
                if (leave?.isConflictingLeave === 1) {
                  setterIdAndModalOpen(
                    actionData,
                    leaveTags.isConflictingLeave
                  );
                  return;
                } else if (actionData?.backupUserId || actionData?.backupName) {
                  setterIdAndModalOpen(actionData, leaveTags.backupUserId);
                } else {
                  setterIdAndModalOpen(actionData, leaveTags.accept);
                }
              }
            }}
            handleCacellationLeave={(actionData, actionType) => {
              if (actionType === "Reject") {
                setterIdAndModalOpen(actionData, leaveTags.cancellationReject);
              } else if (actionType === "Accept") {
                setterIdAndModalOpen(actionData, leaveTags.cancellationAccept);
              }
            }}
            handleArchiveUnaechiveLeave={(actionData, actionType) => {
              if (actionType === "Archive") {
                setterIdAndModalOpen(actionData, leaveTags.archive);
              } else if (actionType === "UnArchive") {
                setterIdAndModalOpen(actionData, leaveTags.unarchive);
              }
            }}
            isLoading={isLoading}
            checkBoxOnChange={(e) => toggleCheckbox(e, leave)}
            checkBoxValue={leave.id}
            checkBoxCheckedValue={selectedLeaveIds?.includes(leave.id)}
            officeId={officeId}
            onRefetch={() => {
              refetch();
            }}
            handleEdit={handleEdit}
            selectedOwnerId={selectedOwnerId}
          />
        ))
      ) : (
        <Empty Message={t("staffTimesheet.leavesEmptyMsg")} />
      )}
    </div>
  );

  return (
    <>
      <Page
        className={"staff-listing-leaves " + styles["staff-listing-leaves"]}
        onBack={onBack}
        title={
          officeDetail && officeDetail.name && <> {t("staffLeaves.leaves")}</>
        }
      >
        {(showLoader || isLoading || isFetching) && <Loader />}

        <div className={styles["sub-head"]}>{officeDetail?.name}</div>
        <div
          className={styles["left-main"] + " " + "leaves_sticky_header_owner"}
        >
          <div className={styles["left-container"]}>
            <div
              className={
                "member-filter review-rating-filter all-option " +
                styles["left-inner"]
              }
            >
              <div className="leaves_select_wrapper">
                <div className="leaves_select_container">
                  <Select
                    className="react-select-container w-25"
                    classNamePrefix="react-select"
                    options={leaveStatusList}
                    value={leaveStatusList?.filter((option) =>
                      (selectedLeaveStatuses || []).includes(option.value)
                    )}
                    onChange={handleOfficeChange}
                    isMulti
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    isClearable={false}
                    isSearchable={false}
                    placeholder="Filter Leaves"
                    components={{
                      Option: CustomOption,
                      MultiValue,
                      ValueContainer: CustomValueContainer,
                      MultiValueRemove: NoRemove,
                    }}
                    styles={customStyles}
                  />
                </div>
              </div>
            </div>
            <div
              className={
                "member-filter review-rating-filter year-option " +
                styles["left-inner"]
              }
            >
              <Select
                options={yearsList}
                defaultValue={{
                  label: cacheValue?.year || new Date().getFullYear(),
                  value: cacheValue?.year || new Date().getFullYear(),
                }}
                className={["react-select-container"]}
                onChange={handleSelectedYear}
                classNamePrefix="react-select"
              />
            </div>

            <img src={SeparatorIcon} alt="SeparatorIcon" />
            <div className={"search-box " + styles["search"]}>
              <input
                type="text"
                value={searchText}
                onChange={handleChange}
                placeholder={t("accountOwner.searchStaff")}
              />
              <span className="ico">
                <img
                  src={require("assets/images/search-icon.svg").default}
                  alt="icon"
                />
              </span>
            </div>
          </div>
          <Button onClick={hanldeApplyModal}>Apply Leave for Staff</Button>
        </div>

        <div className={styles["left-main-mobile"]}>
          <div className={styles.select_search_container}>
            <div
              className={
                "member-filter review-rating-filter all-option " +
                styles["left-inner"]
              }
            >
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={leaveStatusList}
                value={leaveStatusList?.filter((option) =>
                  (selectedLeaveStatuses || []).includes(option.value)
                )}
                onChange={handleOfficeChange}
                isMulti
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                isClearable={false}
                isSearchable={false}
                placeholder="Filter Leaves"
                components={{
                  Option: CustomOption,
                  MultiValue,
                  ValueContainer: CustomValueContainer,
                  MultiValueRemove: NoRemove,
                }}
                styles={customStyles}
              />
            </div>

            <div className={"search-box " + styles["search"]}>
              <input
                type="text"
                value={searchText}
                onChange={handleChange}
                placeholder={t("accountOwner.searchStaff")}
              />
              <span className="ico">
                <img
                  src={require("assets/images/search-icon.svg").default}
                  alt="icon"
                />
              </span>
            </div>
          </div>
          <Button className="w-100" onClick={hanldeApplyModal}>
            Apply Leave for Staff
          </Button>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <div className={"ch-checkbox " + styles["ch-checkbox"]}>
                <label className="m-0">
                  <input
                    type="checkbox"
                    checked={
                      pendingLeaveRecords.length > 0 &&
                      selectedLeaveIds.length === pendingLeaveRecords.length
                    }
                    onChange={toggleAllCheckbox}
                  />
                  <span> {t("staffTimesheet.selectAll")}</span>
                </label>
              </div>
              {selectedLeaveIds.length > 0 && (
                <span className={styles["timesheet-leave-length"]}>
                  ({selectedLeaveIds.length})
                </span>
              )}
              {selectedLeaveIds.length > 0 && (
                <div className={styles.test}>
                  <span
                    title={t("approve")}
                    className="cursor-pointer link-btn mr-3"
                    onClick={() => setIsRejectionModalOpen(leaveTags.accept)}
                  >
                    {t("staffTimesheet.approve")}
                  </span>
                  <span
                    className="link-btn"
                    style={{ color: "#e76f2a" }}
                    title="Reject"
                    onClick={() => setIsRejectionModalOpen(leaveTags.reject)}
                  >
                    <u> {t("reject")}</u>
                  </span>
                </div>
              )}
            </div>
            <div
              className={
                "member-filter review-rating-filter year-option " +
                styles["left-inner"]
              }
            >
              <Select
                options={yearsList}
                defaultValue={{
                  label: cacheValue?.year || new Date().getFullYear(),
                  value: cacheValue?.year || new Date().getFullYear(),
                }}
                className={["react-select-container"]}
                onChange={handleSelectedYear}
                classNamePrefix="react-select"
              />
            </div>
          </div>
        </div>

        <div className={styles["action-container"]}>
          {pendingLeaveRecords.length > 0 && (
            <>
              <div className={styles.approve_reject_btn}>
                <div className={"ch-checkbox " + styles["ch-checkbox"]}>
                  <label>
                    <input
                      type="checkbox"
                      checked={
                        pendingLeaveRecords.length > 0 &&
                        selectedLeaveIds.length === pendingLeaveRecords.length
                      }
                      onChange={toggleAllCheckbox}
                    />
                    <span> {t("staffTimesheet.selectAll")}</span>
                  </label>
                </div>
                {selectedLeaveIds.length > 0 && (
                  <span className={styles["timesheet-leave-length"]}>
                    ({selectedLeaveIds.length})
                  </span>
                )}
              </div>
            </>
          )}
          {selectedLeaveIds.length > 0 && (
            <div>
              <span
                title={t("approve")}
                className="cursor-pointer link-btn mr-3"
                onClick={() => setIsRejectionModalOpen(leaveTags.accept)}
              >
                {t("staffTimesheet.approve")}
              </span>
              <span
                className="link-btn"
                style={{ color: "#e76f2a" }}
                title="Reject"
                onClick={() => setIsRejectionModalOpen(leaveTags.reject)}
              >
                <u> {t("reject")}</u>
              </span>
            </div>
          )}
        </div>
        {renderListing()}
        <PaginationProvider
          pagination={paginationFactory({
            custom: true,
            sizePerPage: PAGE_SIZE,
            totalSize: totalItems,
            page: pageNumber,
            onPageChange: setPageNumber,
          })}
        >
          {({ paginationProps, paginationTableProps }) => {
            return (
              <div className="data-table-block">
                {/* Paginator component needs table to work, this is why we have used it.  */}
                <div style={{ display: "none" }}>
                  <BootstrapTable
                    keyField="id"
                    data={[]}
                    columns={[{ text: "sometext" }]}
                    {...paginationTableProps}
                  />
                </div>
                <div className={"pagnation-block "}>
                  {totalItems > PAGE_SIZE && (
                    <PaginationListStandalone {...paginationProps} />
                  )}
                </div>
              </div>
            );
          }}
        </PaginationProvider>
      </Page>
      {isRejectionModalOpen && (
        <RejectionModal
          isRejectionModalOpen={t("modalForComment." + isRejectionModalOpen)}
          setIsRejectionModalOpen={() => {
            setIsRejectionModalOpen("");
            setSelectedLeaveIds([]);
          }}
          showLoader={showLoader}
          forLeave={true}
          onReject={(reason) => {
            switch (isRejectionModalOpen) {
              case leaveTags.reject:
                acceptRejectLeave(false, reason);
                break;
              case leaveTags.accept:
              case leaveTags.isConflictingLeave:
              case leaveTags.backupUserId:
                acceptRejectLeave(true, reason);
                break;
              case leaveTags.archive:
                applyArchiveActions(true, reason);
                break;
              case leaveTags.unarchive:
                applyArchiveActions(false, reason);
                break;
              case leaveTags.cancellationAccept:
                staffCancelLeaves(true, reason);
                break;
              case leaveTags.cancellationReject:
                staffCancelLeaves(false, reason);
                break;
              default:
                break;
            }
          }}
        />
      )}

      {isSelectStaffModalOpen && (
        <SelectStaff
          isModalOpen={isSelectStaffModalOpen}
          showLoader={showLoader}
          closeModal={handleCancelStaffModal}
          staffMembers={staffMembers}
          staff={Selectedstaff}
          handleStaffRadio={handleStaffRadio}
          handleApply={handleApply}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          handleCancel={handleCancelStaffModal}
          stafftotalItems={stafftotalItems}
          setStaffTotalItems={setStaffTotalItems}
        />
      )}
    </>
  );
};

export default withTranslation()(StaffListingLeaves);
